/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5a41a2fef902308801a22cdbe3ae085>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { GoalsLogo } from './logo';
export { GoalsLogoCS } from './logo-cs';
export { GoalsIcon } from './icon';
